"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = _interopRequireDefault(require("lodash.every"));

var _lodash2 = _interopRequireDefault(require("lodash.has"));

var _lodash3 = _interopRequireDefault(require("lodash.isempty"));

var _lodash4 = _interopRequireDefault(require("lodash.size"));

var _react = _interopRequireDefault(require("react"));

var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } _setPrototypeOf(subClass.prototype, superClass && superClass.prototype); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) { return o.__proto__; }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enhance = function enhance(WrappedComponent) {
  var WithSelections =
  /*#__PURE__*/
  function (_React$Component) {
    function WithSelections() {
      var _getPrototypeOf2;

      var _temp, _this;

      _classCallCheck(this, WithSelections);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithSelections)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
        areAnySelected: false,
        selectedCount: 0,
        selections: {}
      }), "handleClearAll", function () {
        _this.setState(_derivedState({
          selections: {}
        }));
      }), "handleSelect", function (id) {
        _this.setState(function (prevState) {
          if ((0, _lodash2.default)(prevState.selections, id)) {
            // { 1: true } -> {}
            return _derivedState((0, _immutabilityHelper.default)(prevState, {
              selections: {
                $unset: [id]
              }
            }));
          } // {} -> { 1: true }


          return _derivedState((0, _immutabilityHelper.default)(prevState, {
            selections: _defineProperty({}, id, {
              $set: true
            })
          }));
        });
      }), "handleSelectAll", function (items) {
        if ((0, _lodash3.default)(_this.state.selections)) {
          var newSelections = {};
          items.forEach(function (item) {
            newSelections[item.id] = true;
          });

          _this.setState(_derivedState({
            selections: newSelections
          }));
        } else {
          _this.setState(_derivedState({
            selections: {}
          }));
        }
      }), "areAllIndeterminate", function (items) {
        return !(0, _lodash3.default)(_this.state.selections) && !_this.areAllSelected(items);
      }), "areAllSelected", function (items) {
        return (0, _lodash.default)(items, function (item) {
          return (0, _lodash2.default)(_this.state.selections, item.id);
        });
      }), "isItemSelected", function (id) {
        return (0, _lodash2.default)(_this.state.selections, id);
      }), _temp));
    }

    _createClass(WithSelections, [{
      key: "render",
      value: function render() {
        return _react.default.createElement(WrappedComponent, _extends({}, this.props, this.state, {
          handleClearAll: this.handleClearAll,
          handleSelect: this.handleSelect,
          handleSelectAll: this.handleSelectAll,
          areAllIndeterminate: this.areAllIndeterminate,
          areAllSelected: this.areAllSelected,
          isItemSelected: this.isItemSelected
        }));
      }
    }]);

    _inherits(WithSelections, _React$Component);

    return WithSelections;
  }(_react.default.Component);

  function _derivedState(incomingState) {
    // Sets derived state based on new selections
    return Object.assign({}, incomingState, {
      areAnySelected: !(0, _lodash3.default)(incomingState.selections),
      selectedCount: (0, _lodash4.default)(incomingState.selections)
    });
  }

  (0, _hoistNonReactStatics.default)(WithSelections, WrappedComponent);
  WithSelections.displayName = "WithSelections(".concat(WrappedComponent.displayName || WrappedComponent.name || 'Component', ")");
  return WithSelections;
};

var _default = enhance;
exports.default = _default;